let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8ug3B")).then(() => parcelRequire('8BBLJ'));